// extracted by mini-css-extract-plugin
export default {"link":"InstoreReq_link__6lcFv","no_hover":"InstoreReq_no_hover__RxYJB","no-fade":"InstoreReq_no-fade__UPNpi"};